import React from "react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import { useCreateAddressMutation } from "../../../../store/api/address";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import {
	useGetDoctypeDetailsQuery,
	useGetDoctypeitemQuery,
	useLazyGetDoctypeitemQuery,
} from "../../../../store/api/address";
function Address() {
	const location = useLocation();
  // console.log("Params Attached To URL", location.state);
  // console.log("doctype",location?.state?.doctype,"ItemData",location?.state?.itemID);
  

	const navigate = useNavigate();
	const [selectedCompanyaccounts, setSelectedCompanyAccounts] = useState("");
	const [createAddress, { isLoading, iserror, data }] =
		useCreateAddressMutation();
	const [tab, settab] = useState(1);
	const [res, setRes] = useState(false);
	const [error, setError] = useState("");
	const [ptype, setptype] = useState("Error");
	const [showError, setShowError] = useState(false);
	const [isyca, setyca] = useState(0);
	const [status, setStatus] = useState(false);
	const [formdata, setFormData] = useState({
		addressTitle: "",
		AddressType: "",
		AddressLine1: "",
		AddressLine2: "",
		Country: "",
		City: "",
		State: "",
		postalCode: "",
		email: "",
		phone: "",
		Fax: "",
		taxCategory: "",
		pba: false,
		psa: false,
		Disabled: false,
	});

	const handleChange = (e) => {
		const { name, value, type, checked } = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: type === "checkbox" ? checked : value,
		}));
	};
	const handleSubmit = async () => {
		const payload = {
			address_title: formdata.addressTitle,
			address_type: formdata.AddressType,
			address_line1: formdata.AddressLine1,
			address_line2: formdata.AddressLine2,
			city: formdata.City,
			state: formdata.State,
			country: formdata.Country,
			pincode: formdata.postalCode,
			email_id: formdata.email,
			phone: formdata.phone,
			fax: formdata.Fax,
			tax_category: formdata.taxCategory,
			is_primary_address: formdata.pba ? 1 : 0,
			is_shipping_address: formdata.psa ? 1 : 0,
			disabled: formdata.Disabled ? 1 : 0,
			links: selectedCompanyaccounts,
			is_your_company_address: isyca ? 1 : 0,
		};
		// console.log("Payload: ",payload)
		try {
			const res = await createAddress(payload).unwrap();
			setError("Address created successfully!");
			setptype("Success");
			setStatus(true);
			setShowError(true);
			setTimeout(() => {
				navigate("/master/address/address-list");
			}, 3000);
		} catch (error) {
			const parsedMessages = JSON.parse(error.data._server_messages);
			const firstMessageObj = JSON.parse(parsedMessages[0]);
			console.log(firstMessageObj, "errr");
			setError(firstMessageObj.message);
			setptype("Error");
			setShowError(true);
		}
	};
	return (
		<>
			<FormLayout
				title="New Address"
				breadcrumbs={[
					{ label: "Address" },
					{ label: "Address List", url: "/master/address/address-list" },
				]}
				status={"hide"}
				actionButtons={
					<>
						<Button
							className="custom-btn-00989"
							iconName="LuFilePlus2"
							style={{ gap: "2px", height: "28px" }}
							onClick={handleSubmit}
							iconSize={12}
						>
							{/* {po_response.result ? 'Submit' : 'Save'} */}save
						</Button>

						<Button
							to="/brand/create-brand"
							className="px-2"
							imgSrc={printerimg}
							imgStyle={{ width: "21px" }}
						/>
					</>
				}
			>
				<div
					className=""
					style={{ width: "100%", backgroundColor: "#fff", flexGrow: "1" }}
				>
					<div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
						<div className="d-flex justify-content-between align-items-end ">
							<ul
								className="nav nav-tabs"
								style={{ color: "white", border: "none" }}
							>
								<li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
									<a
										className={
											tab == 1
												? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
												: "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
										}
										onClick={() => {
											settab(1);
										}}
										href="javascript:void(0);"
									>
										General Details
										{tab == 1 ? (
											<GetIcon iconName="MdKeyboardArrowDown" size={15} />
										) : (
											<GetIcon iconName="MdKeyboardArrowRight" size={15} />
										)}
									</a>
								</li>
							</ul>
							<div
								className="d-flex align-items-center mb-2 px-3"
								style={{ gap: "2px", fontSize: "12px" }}
							>
								<span style={{ position: "relative", top: "-1px" }}>
									<GetIcon iconName="CgAttachment" size={12} />
								</span>
								<span className=" fw-semibold" style={{ color: "#391F84" }}>
									Attachments
								</span>
							</div>
						</div>
					</div>
					<div
						className="mt-2 py-2"
						style={{ width: "100%", backgroundColor: "#fff", flexGrow: "1" }}
					>
						<div className="row d-flex justify-content-between">
							<div className="col-12">
								<div className="sidebarbox m-0 px-4 py-2">
									<Tab1
										formdata={formdata}
										handleChange={handleChange}
										setFormData={setFormData}
									/>
								</div>
							</div>
						</div>
					</div>
					<div
						className="mt-2 py-2"
						style={{ width: "100%", backgroundColor: "#fff", flexGrow: "1" }}
					>
						<div className="row d-flex justify-content-between">
							<div className="col-12">
								<div className="sidebarbox m-0 px-4 py-2">
									<Tab2
										setSelectedCompanyAccounts={setSelectedCompanyAccounts}
										isyca={isyca}
										setyca={setyca}
                    doctype={location?.state?.doctype}
                    idData={location?.state?.itemID}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<ApiResponseBox
					poptype={ptype}
					show={showError}
					errorMessage={error}
					onClose={() => setShowError(false)}
				/>
			</FormLayout>
		</>
	);
}

export default Address;
